import { action as apiAction } from 'api/Api'
import {
  setIsCardInMyBoard
} from '../redux/myBoard'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setIsCardInMyBoard({
    cardId,
    isCardInMyBoard: false
  }))

  try {
    await apiAction('RemoveVCardFromMyBoard', {
      cardId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
